import { render } from "./LabelInfo.vue?vue&type=template&id=1337dfa8"
import script from "./LabelInfo.vue?vue&type=script&lang=js"
export * from "./LabelInfo.vue?vue&type=script&lang=js"

import "./Styles.scss?vue&type=style&index=0&lang=scss&external"
import "./LabelInfo.vue?vue&type=style&index=1&id=1337dfa8&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__